"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Loadash = require("lodash");
function mapRange(num, inMin, inMax, outMin, outMax) {
    return (num - inMin) * (outMax - outMin) / (inMax - inMin) + outMin;
}
exports.mapRange = mapRange;
function groupBy(collection, propertyExtractor) {
    var i = 0;
    var val;
    var result = {};
    for (; i < collection.length; i++) {
        var ppty = propertyExtractor(collection[i]);
        val = collection[i];
        if (result.hasOwnProperty(ppty)) {
            result[ppty].push(val);
        }
        else {
            result[ppty] = [];
            result[ppty].push(val);
        }
    }
    var arrayResult = [];
    for (var property in result) {
        if (result.hasOwnProperty(property)) {
            var v = result[property];
            var obj = {
                key: property,
                data: v,
            };
            arrayResult.push(obj);
        }
    }
    return arrayResult;
}
exports.groupBy = groupBy;
function subSet(source) {
    var keys = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        keys[_i - 1] = arguments[_i];
    }
    return Loadash.pick(source, keys);
}
exports.subSet = subSet;
function ShallowDiff(oldObject, newObject) {
    var changedKeys = Object.keys(newObject)
        .filter(function (key) {
        var v1 = newObject[key];
        var v2 = oldObject[key];
        if (v1 != undefined && v1.equals != undefined && typeof (v1.equals) === "function") {
            return v1.equals(v2);
        }
        return v1 !== v2;
    });
    if (changedKeys == undefined || changedKeys.length === 0)
        return undefined;
    return subSet.apply(void 0, __spreadArrays([newObject], changedKeys));
}
exports.ShallowDiff = ShallowDiff;
function flatterRArray(input, output) {
    if (output == undefined)
        output = [];
    if (input != undefined) {
        if (Array.isArray(input)) {
            for (var _i = 0, input_1 = input; _i < input_1.length; _i++) {
                var x = input_1[_i];
                flatterRArray(x, output);
            }
        }
        else {
            output.push(input);
        }
    }
    return output;
}
exports.flatterRArray = flatterRArray;
//# sourceMappingURL=Utils.js.map